export default "__VITE_ASSET__BzZ7fg7S__"